import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";

const modules = [
  {
    title: "Introduction to Data Science",
    points: [
      "What is Data Science and its lifecycle",
      "Difference between Data Science, AI, and Machine Learning",
      "Real-world applications of Data Science",
      "Overview of data-driven decision making",
    ],
  },
  {
    title: "Python for Data Science",
    points: [
      "Python environment setup for data science",
      "Core Python concepts for data handling",
      "Working with NumPy for numerical computing",
      "Data manipulation using Pandas",
    ],
  },
  {
    title: "Data Analysis & Visualization",
    points: [
      "Data cleaning and preprocessing techniques",
      "Exploratory Data Analysis (EDA)",
      "Data visualization using Matplotlib and Seaborn",
      "Building meaningful insights from data",
    ],
  },
  {
    title: "Statistics for Data Science",
    points: [
      "Descriptive statistics (mean, median, mode)",
      "Probability basics and distributions",
      "Hypothesis testing fundamentals",
      "Correlation and regression concepts",
    ],
  },
  {
    title: "Machine Learning Fundamentals",
    points: [
      "Introduction to supervised and unsupervised learning",
      "Regression and classification models",
      "Train-test split and model evaluation",
      "Bias, variance, overfitting and underfitting",
    ],
  },
  {
    title: "Data Visualization Tools",
    points: [
      "Power BI dashboard creation basics",
      "Tableau for interactive visualization",
      "Advanced Excel for analytics",
      "Creating business reports and dashboards",
    ],
  },
  {
    title: "SQL for Data Science",
    points: [
      "Database basics and SQL queries",
      "Joins, aggregations, and subqueries",
      "Data extraction and transformation",
      "Working with real datasets using SQL",
    ],
  },
  {
    title: "Tools & Libraries",
    points: [
      "Scikit-learn for machine learning models",
      "Jupyter Notebook for analysis",
      "Pandas advanced operations",
      "Data preprocessing pipelines",
    ],
  },
  {
    title: "Projects & Deployment",
    points: [
      "Real-time data science projects",
      "Building predictive models",
      "Creating dashboards for business insights",
      "Model deployment basics using Flask/FastAPI",
    ],
  },
];

function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
      AOS.init({ duration: 800, once: true });
    }, []);

  return (
    <>
    <section className="syllabus-section">
      <div className="container">
        <div className="headlines-for-all">
          <h4   data-aos="fade-up">
            <span>Course </span> Syllabus
          </h4>
          <p  data-aos="fade-up">
            Explore our comprehensive DataScience syllabus — built for
            real-world projects, hands-on learning, and 100% job readiness.
          </p>
        </div>


        {/* ---------- Desktop Tabs ---------- */}
        {!isMobile && (
          <>
            <div className="custom-btn-group "   data-aos="fade-up">
              {modules.map((m, index) => (
                <button
                  key={index}
                  className={`custom-btn ${activeModule === index ? "active" : ""
                    }`}
                  onClick={() => setActiveModule(index)}
                >
                  Module {index + 1}
                </button>
              ))}
            </div>

            <div className="custom-module-container"   data-aos="fade-up">
              <div className="custom-module-box active">
                <h4>{modules[activeModule].title}</h4>
                <ul className="ul-list-module">
                  {modules[activeModule].points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
        {isMobile && (
          <div className="faq-container-course"   data-aos="fade-up">
            {modules.map((m, index) => (
              <div
                key={index}
                className={`faq-item-course ${activeModule === index ? "open" : ""
                  }`}
              >
                <button
                  className="faq-question-course"
                  onClick={() =>
                    setActiveModule(activeModule === index ? null : index)
                  }
                >
                  {m.title}
                  <span className="faq-icon-course">
                    {activeModule === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer-course"
                  style={{
                    maxHeight: activeModule === index ? "400px" : "0px",
                  }}
                >
                  <ul>
                    {m.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="btn-center"   data-aos="fade-up">
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
        </div>
      </div>
    </section>

  
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default CourseSyllabus;
